export default __webpack_public_path__ + "static/media/pic2.b3958a31.jpg";